import { useState, useEffect } from "react";

const WEDDING = new Date("2026-06-05T14:00:00+02:00").getTime();

function calcTimeLeft() {
  const now = Date.now();
  const diff = WEDDING - now;
  if (diff <= 0) return { giorni: 0, ore: 0, minuti: 0, secondi: 0 };
  return {
    giorni: Math.floor(diff / (1000 * 60 * 60 * 24)),
    ore: Math.floor((diff / (1000 * 60 * 60)) % 24),
    minuti: Math.floor((diff / (1000 * 60)) % 60),
    secondi: Math.floor((diff / 1000) % 60),
  };
}

export default function CountdownTimer() {
  const [time, setTime] = useState(calcTimeLeft);

  useEffect(() => {
    const id = setInterval(() => setTime(calcTimeLeft()), 1000);
    return () => clearInterval(id);
  }, [setTime]);

  const units = [
    { label: "Giorni", value: time.giorni },
    { label: "Ore", value: time.ore },
    { label: "Minuti", value: time.minuti },
    { label: "Secondi", value: time.secondi },
  ];

  return (
    <div
      data-testid="countdown-timer"
      className="flex items-center justify-center gap-4 sm:gap-8"
    >
      {units.map((u) => (
        <div key={u.label} className="text-center">
          <div
            className="font-serif text-3xl sm:text-5xl lg:text-6xl font-semibold"
            style={{ color: "#2C2C2C" }}
          >
            {String(u.value).padStart(2, "0")}
          </div>
          <div
            className="text-xs sm:text-sm mt-1 tracking-widest uppercase"
            style={{ color: "#8B9A6B" }}
          >
            {u.label}
          </div>
        </div>
      ))}
    </div>
  );
}
